export default __webpack_public_path__ + "static/media/sprite.9199c837.svg";